import axios from 'axios';
import apisUrls from '../urls';

const getWebsiteServicesApi = (paramsFilter) => {
  return axios.get(apisUrls?.getWebsiteServicesUrl(paramsFilter));
};

export default getWebsiteServicesApi;
